module.exports = __webpack_public_path__ + "static/media/train13.2f7e85a1.png";